import { Routes } from '@angular/router';
import { AuthGuard } from 'common/guards/auth-guard.service';
import { CheckPermissionsGuard } from 'common/guards/check-permissions-guard.service';
import { AdminComponent } from 'common/admin/admin.component';
import { SettingsComponent } from 'common/admin/settings/settings.component';
import { SettingsResolve } from 'common/admin/settings/settings-resolve.service';
import { vebtoSettingsRoutes } from 'common/admin/settings/settings-routing.module';
import { vebtoAdminRoutes } from '../../common/admin/base-admin-routing.module';
var ɵ0 = { permissions: ['admin.access'] }, ɵ1 = { permissions: ['settings.view'] };
var routes = [
    {
        path: '',
        component: AdminComponent,
        canActivate: [AuthGuard, CheckPermissionsGuard],
        canActivateChild: [AuthGuard, CheckPermissionsGuard],
        data: ɵ0,
        children: [
            {
                path: 'settings',
                component: SettingsComponent,
                resolve: { settings: SettingsResolve },
                data: ɵ1,
                children: vebtoSettingsRoutes.slice(),
            }
        ].concat(vebtoAdminRoutes)
    }
];
var AppAdminRoutingModule = /** @class */ (function () {
    function AppAdminRoutingModule() {
    }
    return AppAdminRoutingModule;
}());
export { AppAdminRoutingModule };
export { ɵ0, ɵ1 };
